var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755,
    height: 561,
    viewBox: "0 0 755 561",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1619_4166)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1619_4166)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 675,
    height: 481,
    rx: 16,
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 321C233 317.686 235.686 315 239 315H722V556H233V321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 355,
    r: 20,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 335,
    width: 160,
    height: 16,
    rx: 2,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 363,
    width: 278,
    height: 16,
    rx: 2,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 391,
    width: 418,
    height: 16,
    rx: 2,
    fill: "#C8CDD4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 459,
    r: 20,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 439,
    width: 160,
    height: 16,
    rx: 2,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 467,
    width: 278,
    height: 16,
    rx: 2,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 495,
    width: 418,
    height: 16,
    rx: 2,
    fill: "#C8CDD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 165C233 161.686 235.686 159 239 159H722V299H239C235.686 299 233 296.314 233 293V165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249 183C249 180.791 250.791 179 253 179H441C443.209 179 445 180.791 445 183V203C445 205.209 443.209 207 441 207H253C250.791 207 249 205.209 249 203V183Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 239,
    width: 466,
    height: 16,
    rx: 2,
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 263,
    width: 269,
    height: 16,
    rx: 2,
    fill: "#C8CDD4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249,
    y1: 222.5,
    x2: 714,
    y2: 222.5,
    stroke: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 86H242.4V78.2L246 86H247.2L250.8 78.2V86H252.7V73.4H251.1L246.6 83.1L242.1 73.4H240.5V86ZM255.895 89.2L256.075 89.26C256.215 89.28 256.335 89.3 256.495 89.3C257.895 89.3 258.595 88.6 259.395 86.6L263.195 77H261.295L258.795 83.5L256.295 77H254.395L257.895 85.7L257.595 86.6C257.375 87.22 256.915 87.7 255.895 87.7V89.2ZM271.189 84.2V75.2H273.089C275.169 75.2 277.189 77.1 277.189 79.7C277.189 82.3 275.169 84.2 273.089 84.2H271.189ZM269.289 86H273.089C276.289 86 279.089 83.2 279.089 79.7C279.089 76.2 276.289 73.4 273.089 73.4H269.289V86ZM286.681 86H287.981V80.1C287.981 78.3 286.581 76.9 284.481 76.9C282.261 76.9 280.981 78.1 280.881 79.7H282.681C282.781 79.08 283.281 78.6 284.481 78.6C285.601 78.6 286.181 79.2 286.181 80.1V80.4C281.781 80.4 280.581 81.6 280.581 83.4C280.581 85 281.681 86.1 283.681 86.1C284.581 86.1 285.241 85.86 285.661 85.6C285.901 85.46 286.101 85.28 286.281 85.1L286.681 86ZM286.181 82.48C286.181 83.6 285.301 84.5 283.781 84.5C282.881 84.5 282.381 84 282.381 83.5C282.381 82.6 282.981 82 286.181 82V82.48ZM289.778 83.1C289.878 85.02 290.958 86.1 293.178 86.1C295.278 86.1 296.478 84.9 296.478 83.3C296.478 80.12 291.678 81.2 291.678 79.6C291.678 79.1 292.178 78.6 293.078 78.6C293.978 78.6 294.478 79.08 294.578 79.7H296.378C296.278 78 295.178 76.9 293.078 76.9C291.178 76.9 289.978 78.1 289.978 79.6C289.978 82.78 294.778 81.7 294.778 83.3C294.778 83.92 294.298 84.4 293.178 84.4C292.158 84.4 291.678 83.9 291.578 83.1H289.778ZM298.484 86H300.284V80.8C300.284 79.62 301.264 78.6 302.484 78.6C303.604 78.6 304.584 79.62 304.584 80.8V86H306.384V80.8C306.384 78.5 304.784 76.9 302.784 76.9C301.984 76.9 301.344 77.16 300.924 77.4C300.684 77.54 300.464 77.72 300.284 77.9V73.4H298.484V86ZM308.777 86H310.077L310.477 85.1C310.657 85.28 310.857 85.46 311.097 85.6C311.517 85.86 312.177 86.1 313.077 86.1C315.477 86.1 317.377 84.2 317.377 81.5C317.377 78.8 315.477 76.9 313.077 76.9C312.217 76.9 311.617 77.16 311.197 77.4C310.957 77.54 310.757 77.72 310.577 77.9V73.4H308.777V86ZM312.977 84.4C311.597 84.4 310.377 83.2 310.377 81.5C310.377 79.8 311.597 78.6 312.977 78.6C314.357 78.6 315.577 79.8 315.577 81.5C315.577 83.2 314.357 84.4 312.977 84.4ZM323.082 84.4C321.782 84.4 320.582 83.2 320.582 81.5C320.582 79.8 321.782 78.6 323.082 78.6C324.382 78.6 325.582 79.8 325.582 81.5C325.582 83.2 324.382 84.4 323.082 84.4ZM323.082 86.1C325.482 86.1 327.382 84.2 327.382 81.5C327.382 78.8 325.482 76.9 323.082 76.9C320.682 76.9 318.782 78.8 318.782 81.5C318.782 84.2 320.682 86.1 323.082 86.1ZM334.982 86H336.282V80.1C336.282 78.3 334.882 76.9 332.782 76.9C330.562 76.9 329.282 78.1 329.182 79.7H330.982C331.082 79.08 331.582 78.6 332.782 78.6C333.902 78.6 334.482 79.2 334.482 80.1V80.4C330.082 80.4 328.882 81.6 328.882 83.4C328.882 85 329.982 86.1 331.982 86.1C332.882 86.1 333.542 85.86 333.962 85.6C334.202 85.46 334.402 85.28 334.582 85.1L334.982 86ZM334.482 82.48C334.482 83.6 333.602 84.5 332.082 84.5C331.182 84.5 330.682 84 330.682 83.5C330.682 82.6 331.282 82 334.482 82V82.48ZM338.579 86H340.379V80.9C340.379 79.72 341.359 78.7 342.579 78.7C342.719 78.7 342.859 78.74 342.999 78.76L343.179 78.8V77L343.019 76.96C342.919 76.94 342.799 76.9 342.579 76.9C341.799 76.9 341.239 77.16 340.859 77.4C340.639 77.54 340.439 77.72 340.279 77.9L339.879 77H338.579V86ZM351.57 86H352.87V73.4H351.07V77.9C350.89 77.72 350.69 77.54 350.45 77.4C350.03 77.16 349.43 76.9 348.57 76.9C346.17 76.9 344.27 78.8 344.27 81.5C344.27 84.2 346.17 86.1 348.57 86.1C349.47 86.1 350.13 85.86 350.55 85.6C350.79 85.46 350.99 85.28 351.17 85.1L351.57 86ZM348.67 84.4C347.29 84.4 346.07 83.2 346.07 81.5C346.07 79.8 347.29 78.6 348.67 78.6C350.05 78.6 351.27 79.8 351.27 81.5C351.27 83.2 350.05 84.4 348.67 84.4Z",
    fill: "#77828D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 52C36 43.1634 43.1634 36 52 36H209V517H52C43.1634 517 36 509.837 36 501V52Z",
    fill: "#5E6777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 137C233 140.314 235.686 143 239 143H711V107H239C235.686 107 233 109.686 233 113V137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1619_4166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251 123.667C251 124.28 251.121 124.886 251.355 125.453C251.59 126.019 251.933 126.533 252.367 126.966C252.8 127.4 253.315 127.744 253.881 127.978C254.447 128.213 255.054 128.333 255.667 128.333C256.28 128.333 256.886 128.213 257.453 127.978C258.019 127.744 258.533 127.4 258.966 126.966C259.4 126.533 259.744 126.019 259.978 125.453C260.213 124.886 260.333 124.28 260.333 123.667C260.333 123.054 260.213 122.447 259.978 121.881C259.744 121.315 259.4 120.8 258.966 120.367C258.533 119.933 258.019 119.59 257.453 119.355C256.886 119.121 256.28 119 255.667 119C255.054 119 254.447 119.121 253.881 119.355C253.315 119.59 252.8 119.933 252.367 120.367C251.933 120.8 251.59 121.315 251.355 121.881C251.121 122.447 251 123.054 251 123.667Z",
    stroke: "#9099A8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 131L259 127",
    stroke: "#9099A8",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.64 127.04C273.64 128.8 274.904 130.08 277 130.08C279.096 130.08 280.36 128.8 280.36 127.36C280.36 123.76 275 125.04 275 122.56C275 121.744 275.8 120.96 277 120.96C278.04 120.96 278.84 121.744 278.84 122.88H280.12C280.12 121.2 278.744 119.84 277 119.84C275.08 119.84 273.72 121.2 273.72 122.56C273.72 126.16 279.08 124.88 279.08 127.36C279.08 128.256 278.36 128.96 277 128.96C275.64 128.96 274.92 128.256 274.92 127.04H273.64ZM286.682 128.08C286.442 128.416 285.866 128.96 284.922 128.96C283.786 128.96 282.842 128 282.762 126.96H288.042L288.074 126.784C288.09 126.672 288.122 126.528 288.122 126.32C288.122 124.144 286.602 122.72 284.842 122.72C283.098 122.72 281.482 124.24 281.482 126.4C281.482 128.56 283.002 130.08 284.922 130.08C286.522 130.08 287.482 129.12 287.962 128.08H286.682ZM282.762 125.92C282.938 124.72 283.802 123.84 284.842 123.84C285.882 123.84 286.746 124.72 286.922 125.92H282.762ZM294.288 130H295.168V125.2C295.168 123.856 294.048 122.72 292.448 122.72C290.848 122.72 289.904 123.68 289.728 124.88H291.008C291.184 124.24 291.552 123.84 292.448 123.84C293.344 123.84 293.968 124.48 293.968 125.2V125.6C290.368 125.6 289.408 126.56 289.408 127.92C289.408 129.12 290.368 130.08 291.808 130.08C292.528 130.08 293.056 129.888 293.424 129.648C293.632 129.52 293.808 129.376 293.968 129.2L294.288 130ZM293.968 127.28C293.968 128.08 293.088 128.96 291.808 128.96C291.088 128.96 290.608 128.496 290.608 128C290.608 127.2 291.088 126.72 293.968 126.72V127.28ZM297.165 130H298.365V125.92C298.365 124.704 299.149 123.92 300.285 123.92H300.605V122.72H300.445C299.757 122.72 299.261 122.928 298.893 123.168C298.685 123.296 298.509 123.44 298.365 123.6L298.045 122.8H297.165V130ZM306.762 127.44C306.506 128.24 305.786 128.96 304.842 128.96C303.722 128.96 302.682 127.936 302.682 126.4C302.682 124.864 303.722 123.84 304.842 123.84C305.786 123.84 306.506 124.56 306.762 125.36H307.962C307.626 123.904 306.442 122.72 304.842 122.72C302.986 122.72 301.482 124.24 301.482 126.4C301.482 128.56 302.986 130.08 304.842 130.08C306.442 130.08 307.626 128.896 307.962 127.44H306.762ZM309.558 130H310.758V125.84C310.758 124.624 311.542 123.84 312.678 123.84C313.622 123.84 314.438 124.64 314.438 125.84V130H315.638V125.84C315.638 124 314.358 122.72 312.838 122.72C312.15 122.72 311.654 122.96 311.286 123.2C311.078 123.344 310.902 123.504 310.758 123.68V119.92H309.558V130ZM317.154 129.04C317.154 129.6 317.634 130.08 318.194 130.08C318.754 130.08 319.234 129.6 319.234 129.04C319.234 128.48 318.754 128 318.194 128C317.634 128 317.154 128.48 317.154 129.04ZM320.357 129.04C320.357 129.6 320.837 130.08 321.397 130.08C321.957 130.08 322.437 129.6 322.437 129.04C322.437 128.48 321.957 128 321.397 128C320.837 128 320.357 128.48 320.357 129.04ZM323.56 129.04C323.56 129.6 324.04 130.08 324.6 130.08C325.16 130.08 325.64 129.6 325.64 129.04C325.64 128.48 325.16 128 324.6 128C324.04 128 323.56 128.48 323.56 129.04Z",
    fill: "#77828D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1619_4166",
    x: 0,
    y: 0,
    width: 755,
    height: 561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1619_4166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1619_4166",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1619_4166"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 675,
    height: 481,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1619_4166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(249 117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.aa584c91b7ed0645724ddaa6a0047080.svg";
export { ForwardRef as ReactComponent };